export const QUESTIONS_ACTION = {
  CHANGE_CURRENT_INDEX: 'QUESTIONS_ACTION/CHANGE_CURRENT_INDEX',
};

export const changeCurrentIndex = (index: number) => ({
  type: QUESTIONS_ACTION.CHANGE_CURRENT_INDEX,
  index,
});
